import { render, staticRenderFns } from "./SkinDysfunctionsTemplate.vue?vue&type=template&id=2792f665&scoped=true"
import script from "./SkinDysfunctionsTemplate.vue?vue&type=script&lang=js"
export * from "./SkinDysfunctionsTemplate.vue?vue&type=script&lang=js"
import style0 from "./SkinDysfunctionsTemplate.vue?vue&type=style&index=0&id=2792f665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2792f665",
  null
  
)

export default component.exports